exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title___3zSps {\n  color: #21201f;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28px;\n  margin: 0;\n}\n.text___uhhAY {\n  color: #505050;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 12px 0 0;\n}\n.text___uhhAY + .text___uhhAY {\n  font-weight: 600;\n}\n.fieldWrapper___1wPQ1 {\n  margin: 20px 0 0;\n}\n.cta___5zRJt {\n  width: 100%;\n}\n.errorWrapper___29qZ2 {\n  margin: 10px 0;\n}\n.errorWrapper___29qZ2 .zola-ui.banner {\n  padding: 12px 20px;\n}\n", ""]);

// exports
exports.locals = {
	"title": "title___3zSps",
	"text": "text___uhhAY",
	"fieldWrapper": "fieldWrapper___1wPQ1",
	"cta": "cta___5zRJt",
	"errorWrapper": "errorWrapper___29qZ2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/paper/components/SimpleSignUpForm/styles.module.less
// module id = 1712
// module chunks = 71